export default "__VITE_ASSET__7d2421ca__"